import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import axios from "axios";
import {APIURL, PORT} from "../../config/config";
import { AlertError, AlertSuccess, AlertWarning } from "../Alert/Alert";
import BDatePicker from "../BDatePicker";
import Swal from "sweetalert2";
import { CustomerUtil } from "../../utils/cutomerUtil";
// import { fa } from "faker/lib/locales";
import Loading from "../Loading";
// import { format } from 'date-fns'
// import { CustomerFollowupUtils } from "./CustomerFollowupUtils";

class CustomerFollowupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customer_name: "",
      customer_lastname: "",
      customer_mobile: "",
      customer_note: "",
      followup_by: null,
      accounts: [],
      admin_social: null,
      admin_socials: [],
      car_type_interest: "",
      car_type_interests: [
        { car_type: "เก๋ง" },
        { car_type: "กระบะ" },
        { car_type: "SUV" },
        { car_type: "ตอนเดียว" },
        { car_type: "จักรยานยนต์" },
      ],
      customer_id: this.props.customer_id,
      //
      followup_id: this.props.followup_id,
      followup_times: null,
      contact_date: null,
      followup_date: null,
      followup_detail: null,
      followup_next: null,
      //
      is_reload: false,
      // customer_type lead , reject , cancel, complete
      customer_type: "lead",
      // customer_types: CustomerFollowupUtils.getCustomerTypes(),
      profile_froms: [],
      profile_from: "",
      profile_id: null,
      walkin_level_list: CustomerUtil.getWalkInLevelList(),
      walkin_level: "",
      customer_list: [],
      is_customer_selected: false,
      isLoading: false,
      customer_types: [],
      customer_type_leads: ["lead", "wait", "appointment", "deciding"],
    };
    this.handleOnSubmitCustomer = this.handleOnSubmitCustomer.bind(this);
    this.handleOnSubmitCustomerFollowUp =
      this.handleOnSubmitCustomerFollowUp.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.loadAccountData = this.loadAccountData.bind(this);
    this.loadCustomerLead = this.loadCustomerLead.bind(this);
    this.loadProfileFrom = this.loadProfileFrom.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.onCustomerSelect = this.onCustomerSelect.bind(this);
    this.loadCustomerTypes = this.loadCustomerTypes.bind(this);
    this.loadAdminSocialData = this.loadAdminSocialData.bind(this);
  }

  componentDidMount() {
    this.loadAccountData();
    this.loadProfileFrom();
    this.loadCustomerTypes();
    this.loadAdminSocialData();

    let customer_id = this.props.customer_id;
    if (customer_id !== null) {
      this.loadCustomerLead(customer_id);
    } else {
      //  followup_by:
      this.setState({
        followup_by: this.props.user.type === "sale" ? this.props.user.user : this.props.user.user,
        admin_social: this.props.user.type === "adminsocial" ? this.props.user.user : this.props.user.user,
      });
    }
  }

  loadCustomerTypes() {
    axios
      .get(APIURL + "/customer/followup/customer_types")
      .then((res) => {
        this.setState({ customer_types: res.data });
      })
      .catch((error) => {
        this.setState({ customer_types: [] });
      });
  }

  loadProfileFrom() {
    axios
      .get(APIURL + "/profile_from")
      .then((res) => {
        this.setState({ profile_froms: res.data });
      })
      .catch((error) => {
        this.setState({ profile_froms: [] });
      });
  }

  loadAdminSocialData() {
    axios
      .get(APIURL + "/account/type/adminsocial")
      .then((res) => {
        this.setState({ admin_socials: res.data });
      })
      .catch((error) => {
        this.setState({ admin_socials: [] });
      });
  }

  loadCustomerLead(customer_id) {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        let uri = APIURL + "/customer/" + customer_id;
        axios
          .get(uri)
          .then((res) => {
            let customer = res.data[0];

            this.setState({
              customer_name: customer.customer_name,
              customer_lastname: customer.customer_lastname,
              customer_mobile: customer.customer_mobile,
              car_type_interest: customer.car_type_interest,
              customer_note: customer.customer_note,
              followup_by: customer.followup_by,
              admin_social: customer.admin_social,
              customer_id: customer.customer_id,
              customer_type: customer.customer_type,
              walkin_level: customer.walkin_level,
              profile_from: customer.profile_from,
              profile_id: customer.profile_id,
              isLoading: false,
            });
          })
          .catch((err) => {
            console.log("err=", err);
          });
      }
    );
  }

  handleOnSubmitCustomer(e) {
    e.preventDefault();
    let username = this.props.user.user;
    let type = this.props.user.type;
    let customer_name = this.state.customer_name;
    let customer_lastname = this.state.customer_lastname;
    let customer_mobile = this.state.customer_mobile;
    let car_type_interest = this.state.car_type_interest;
    let customer_note = this.state.customer_note;
    let customer_id = this.state.customer_id;
    let customer_type = this.state.customer_type;
    let profile_from = this.state.profile_from;
    let profile_id = this.state.profile_id;
    let walkin_level = this.state.walkin_level;
    let admin_social = this.state.admin_social;

    let followup_by = null;
    if (type !== "admin") {
      followup_by = username;
    } else if (type === "admin") {
      followup_by = this.state.followup_by;
    }

    if (
      customer_name === "" ||
      customer_lastname === "" ||
      customer_mobile === ""
    ) {
      AlertWarning("กรุณากรอกข้อมูลลูกค้า\n ให้ครบถ้วน");
      return;
    }

    if (followup_by === null || followup_by === "") {
      AlertWarning("กรุณาเลือกติดตามโดย");
      return;
    }

    if (profile_from === "") {
      AlertWarning("กรุณาเลือกลูกค้าจาก");
      return;
    }

    let data = {
      customer_name,
      customer_lastname,
      customer_mobile,
      car_type_interest,
      customer_note,
      followup_by,
      admin_social,
      username,
      customer_type,
      profile_from,
      profile_id,
      walkin_level,
    };

    if (customer_id === null) {
      let uri = APIURL + "/customer/followup/lead";
      axios
        .post(uri, data)
        .then((res) => {
          let result = res.data.result;
          let customer_id = res.data.customer_id;

          if (result === "success") {
            AlertSuccess("บันทึกข้อมูลลูกค้า(Lead) เรียบร้อยแล้ว");
            this.setState({
              customer_id: customer_id,
              is_reload: true,
            });
          }
        })
        .catch((error) => {
          console.log("error:", error);
          this.setState({
            customer_id: null,
          });
        });
    } else {
      let uri = APIURL + "/customer/followup/lead/" + customer_id;
      let dataUpdate = { ...data, customer_id: customer_id };

      axios.put(uri, dataUpdate).then((res) => {
        let result = res.data.result;
        if (result === "success") {
          AlertSuccess("แก้ไขข้อมูลลูกค้า(Lead) เรียบร้อยแล้ว");
          this.setState({
            is_reload: true,
          });
        }
      });
    }
  }

  handleOnSubmitCustomerFollowUp(e) {
    e.preventDefault();
    let customer_id = this.state.customer_id;
    if (customer_id === null) {
      AlertError("กรุณาบันทึกข้อมูลลูกค้าก่อน");
      return;
    }

    const {
      followup_id,
      followup_times,
      contact_date,
      followup_date,
      followup_detail,
      followup_next,
      walkin_level,
    } = this.state;

    if (
      followup_times === 0 ||
      contact_date === null ||
      followup_date === null ||
      followup_detail === null ||
      followup_next === null
    ) {
      AlertWarning("กรุณากรอกข้อมูลการติดต่อ\nให้ครบถ้วน");
      return;
    }

    if (contact_date > followup_date) {
      AlertWarning("วันที่ไม่ถูกต้องกรุณาตรวจสอบ");
      return;
    }

    let username = this.props.user.user;
    let data = {
      customer_id,
      followup_times,
      contact_date,
      followup_date,
      followup_detail,
      followup_next,
      username,
      walkin_level,
    };

    if (followup_id === null) {
      // add
      let uri = APIURL + "/customer/followup";
      axios.post(uri, data).then((res) => {
        let result = res.data.result;
        let followup_id = res.data.followup_id;
        if (result === "success") {
          AlertSuccess("บันทึกข้อมูลการติดต่อ\nเรียบร้อยแล้ว");
          this.setState({
            followup_id: followup_id,
            is_reload: true,
          });
        }
      });
    } else {
      // edit
      let uri = APIURL + "/customer/followup/" + followup_id;
      axios.put(uri, data).then((res) => {
        let result = res.data.result;
        if (result === "success") {
          AlertSuccess("แก้ไขข้อมูลการติดต่อ\nเรียบร้อยแล้ว");
          this.setState({
            is_reload: true,
          });
        }
      });
    }
  }

  onInputChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({
      [name]: value,
    });
  }

  loadAccountData() {
    axios
      .get(APIURL + "/account/")
      .then((res) => {
        this.setState({ accounts: res.data });
      })
      .catch((error) => {
        this.setState({ accounts: [] });
      });
  }

  searchCustomer() {
    let search_text = this.refs.search_customer_name.value;

    if (search_text.length < 3) {
      AlertWarning("กรุณากรอกมากกกว่า 3 ตัวอักษร");
      return;
    }

    this.setState(
      {
        isLoading: true,
      },
      () => {
        axios
          .get(APIURL + "/customer/search/" + search_text)
          .then((res) => {
            if (res.status === 200) {
              this.setState({
                customer_list: res.data,
                is_customer_selected: false,
                isLoading: false,
              });
            }
          })
          .catch((error) => {
            console.log("error: ", error);
            this.setState({
              customer_list: [],
              is_customer_selected: false,
              isLoading: false,
            });
          });
      }
    );
  }

  onCustomerSelect(customer) {
    let customer_id = customer.customer_id;
    this.setState(
      {
        is_customer_selected: true,
      },
      () => {
        this.loadCustomerLead(customer_id);
      }
    );
  }

  render() {
    const { isOpen, user, admin_followup_by } = this.props;

    let type = user.type;

    const { accounts, car_type_interests } = this.state;

    let account_list = accounts.map((account, index) => (
      <option key={index} value={account.user}>
        {account.user}
      </option>
    ));

    let admin_social_list = this.state.admin_socials.map((admin, index) => (
      <option key={index} value={admin.user}>
        {admin.user}
      </option>
    ));

    let car_type_interest_list = car_type_interests.map(
      (car_type_interest, index) => (
        <option key={index} value={car_type_interest.car_type}>
          {car_type_interest.car_type}
        </option>
      )
    );

    let walkin_level_list = this.state.walkin_level_list.map(
      (walkin_level, index) => {
        return (
          <option key={index} value={walkin_level.walkin_level_name}>
            {" "}
            {walkin_level.walkin_level_name}{" "}
          </option>
        );
      }
    );

    let search_customer_list = this.state.customer_list.map(
      (customer_list, index) => {
        return (
          <tr key={index}>
            <td>
              <strong>ชื่อ</strong> &nbsp;&nbsp; {customer_list.customer_name}
            </td>
            <td>
              <strong>นามสกุล</strong> &nbsp;&nbsp;{" "}
              {customer_list.customer_lastname}
            </td>
            <td>
              <strong>เลขบัตร ปชช.</strong> &nbsp;&nbsp;{" "}
              {customer_list.customer_card_id}
            </td>
            <td>
              <strong>เบอร์โทรศัพท์</strong> &nbsp;&nbsp;{" "}
              {customer_list.customer_mobile}
            </td>
            <td>
              <button
                onClick={() => this.onCustomerSelect(customer_list)}
                type="button"
                className="btn btn-primary"
              >
                <i className="fa fa-hand-pointer-o" />
                &nbsp;&nbsp; เลือก
              </button>
            </td>
          </tr>
        );
      }
    );

    return (
      <Modal
        isOpen={isOpen}
        toggle={this.props.onToggle}
        className="modal-book-lg"
        backdrop={"static"}
      >
        <ModalBody>
          <div>
            <Loading isLoading={this.state.isLoading} />

            <div className="row">
              <div className="col-lg-6">
                <form
                  action=""
                  method="post"
                  onSubmit={this.handleOnSubmitCustomer}
                >
                  <div className="card card-accent-primary">
                    <div className="card-header">
                      <strong>ข้อมูลลูกค้า(Lead)</strong> &nbsp;&nbsp;
                    </div>
                    <div className="card-block">
                      <div className="row">
                        <div className="form-group col-sm-12">
                          <div className="input-group has-success ">
                            <input
                              ref="search_customer_name"
                              placeholder="ค้นหาชื่อลูกค้าหรือเบอร์โทร"
                              className="form-control"
                              size="16"
                              type="text"
                            />

                            <span className="input-group-btn ">
                              <button
                                className="btn btn-success"
                                type="button"
                                onClick={this.searchCustomer.bind(this)}
                              >
                                ค้นหา
                              </button>
                            </span>
                          </div>
                        </div>
                        {this.state.customer_list.length != 0 &&
                        this.state.is_customer_selected === false ? (
                          <div className="form-group col-sm-12">
                            <table className="table table-striped">
                              <tbody>{search_customer_list}</tbody>
                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="row">
                        <div className="form-group col-sm-6">
                          <label htmlFor="customer_name">ชื่อ</label>
                          <input
                            type="text"
                            className="form-control"
                            name="customer_name"
                            placeholder=""
                            maxLength={50}
                            value={this.state.customer_name || ""}
                            onChange={this.onInputChange}
                          />
                        </div>
                        <div className="form-group col-sm-6">
                          <label htmlFor="customer_lastname">นามสกุล</label>
                          <input
                            type="text"
                            className="form-control"
                            name="customer_lastname"
                            placeholder=""
                            maxLength={50}
                            value={this.state.customer_lastname || ""}
                            onChange={this.onInputChange}
                          />
                        </div>

                        <div className="form-group col-sm-6">
                          <label htmlFor="customer_mobile">เบอร์โทรศัพท์</label>
                          <input
                            type="text"
                            className="form-control"
                            name="customer_mobile"
                            placeholder=""
                            maxLength={20}
                            value={this.state.customer_mobile || ""}
                            onChange={this.onInputChange}
                          />
                        </div>

                        <div className="form-group col-sm-6">
                          <label htmlFor="walkin_level">
                            ระดับความต้องการของลูกค้า
                          </label>
                          {/*<input type="text"
                                   className="form-control"
                                   id="walkin_level"
                                   placeholder=""
                                   ref="walkin_level"
                                   value={this.state.walkin_level}
                                   onChange={this.onInputChangeCustomerStoreFront}
                            />*/}
                          <select
                            className="form-control"
                            id="walkin_level"
                            name="walkin_level"
                            value={this.state.walkin_level || ""}
                            onChange={(e) => {
                              this.setState({ walkin_level: e.target.value });
                            }}
                          >
                            <option value=""> ระบุระดับความต้องการ </option>
                            {walkin_level_list}
                          </select>
                        </div>

                        <div className="form-group col-sm-12">
                          <label htmlFor="customer_note">
                            รายละเอียดลูกค้า
                          </label>
                          <textarea
                            className="form-control"
                            name="customer_note"
                            placeholder=""
                            value={this.state.customer_note || ""}
                            onChange={this.onInputChange}
                          />
                        </div>

                        <div className="form-group col-md-6">
                          <label htmlFor="car_type_interest">
                            ประเภทรถที่สนใจ
                          </label>
                          <select
                            className="form-control"
                            name="car_type_interest"
                            value={this.state.car_type_interest || ""}
                            onChange={(e) => {
                              let value = e.target.value;
                              this.setState({
                                car_type_interest: value,
                              });
                            }}
                          >
                            <option key={-1} value="">
                              เลือกประเภทรถ
                            </option>
                            {car_type_interest_list}
                          </select>
                        </div>

                        <div className="form-group col-md-6">
                          <label htmlFor="car_type_interest">ลูกค้าจาก</label>
                          <select
                            className="form-control"
                            name="profile_from"
                            value={this.state.profile_from || ""}
                            onChange={(e) => {
                              let value = e.target.value;
                              this.setState({
                                profile_from: value,
                              });
                            }}
                          >
                            <option key={-1} value="">
                              -- เลือก --
                            </option>
                            {this.state.profile_froms.map(
                              (profile_from, index) => (
                                <option
                                  key={index}
                                  value={profile_from.profile_from_name}
                                >
                                  {profile_from.profile_from_name}
                                </option>
                              )
                            )}
                          </select>
                        </div>

                        <div className="form-group col-md-6">
                          <label htmlFor="customer_type">สถานะ</label>
                          <select
                            className="form-control"
                            name="customer_type"
                            value={this.state.customer_type || ""}
                            onChange={(e) => {
                              let value = e.target.value;
                              let customer_type_leads =
                                this.state.customer_type_leads;

                              if (!customer_type_leads.includes(value)) {
                                let customer_types =
                                  this.state.customer_types.filter(
                                    (customer_type) =>
                                      customer_type.customer_type === value
                                  )[0];
                                let customer_label =
                                  customer_types.customer_type_name;
                                Swal.fire({
                                  title:
                                    "การเปลี่ยนสถานะเป็น " +
                                    customer_label +
                                    " ลูกค้าจะไม่ถูกติดตามและไม่แจ้งเตือนในปฏิทินการติดตาม",
                                  icon: "warning",
                                  showConfirmButton: true,
                                  showCancelButton: true,
                                }).then((result) => {
                                  if (result.value) {
                                    this.setState({
                                      customer_type: value,
                                    });
                                  }
                                });
                              } else {
                                this.setState({
                                  customer_type: value,
                                });
                              }
                            }}
                          >
                            {this.state.customer_types.map(
                              (customer_type, index) => (
                                <option
                                  key={index}
                                  value={customer_type.customer_type}
                                >
                                  {customer_type.customer_type_name}
                                </option>
                              )
                            )}
                          </select>
                        </div>

                        {type !== "admin" && type !== "adminsocial" ?  (
                          <div className="form-group col-sm-6">
                            <label htmlFor="customer_mobile">ติดตามโดย</label>
                            <input
                              type="text"
                              className="form-control"
                              name="followup_by"
                              placeholder=""
                              maxLength={45}
                              disabled={true}
                              value={this.state.followup_by || ""}
                              onChange={() => {}}
                            />
                          </div>
                        ) : null}

                        {type === "admin" || type === "adminsocial" ? (
                          <div className="form-group col-md-6">
                            <label htmlFor="followup_by">ติดตามโดย</label>
                            <select
                              className="form-control"
                              name="followup_by"
                              value={this.state.followup_by || ""}
                              onChange={(e) => {
                                let value = e.target.value;
                                this.setState({
                                  followup_by: value,
                                });
                              }}
                            >
                              <option value="">เลือกผู้ติดตาม</option>
                              {account_list}
                            </select>
                          </div>
                        ) : null}

                        {/*ลูกค้าจากแอดมิน*/}
                        {PORT === 9064 && type === "admin" || type === "sale" ? (
                        <div className="form-group col-md-6">
                          <label htmlFor="admin_social">ลูกค้าจากแอดมิน</label>
                          <select
                            className="form-control"
                            name="admin_social"
                            value={this.state.admin_social || ""}
                            onChange={(e) => {
                              let value = e.target.value;
                              this.setState({
                                admin_social: value,
                              });
                            }}
                          >
                            <option value="">ไม่ระบุ</option>
                            {admin_social_list}
                          </select>
                        </div>
                        ) : null}

                        {PORT === 9064 && type === "adminsocial" ?  (
                            <div className="form-group col-sm-6">
                              <label htmlFor="admin_social">ลูกค้าจากแอดมิน</label>
                              <input
                                  type="text"
                                  className="form-control"
                                  name="admin_social"
                                  placeholder=""
                                  maxLength={45}
                                  disabled={true}
                                  value={this.state.admin_social || ""}
                                  onChange={() => {}}
                              />
                            </div>
                        ) : null}

                      </div>
                    </div>
                    <div className="card-footer text-right">
                      {this.state.customer_id === null ? (
                        <button type="submit" className="btn btn-primary">
                          <i className="icon-check"/> บันทึกลูกค้า(Lead)
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-warning">
                          <i className="icon-pencil"/> แก้ไขลูกค้า(Lead)
                        </button>
                      )}
                    </div>
                  </div>
                </form>
              </div>
              <div className="col-lg-6">
                <form
                  action=""
                  method="post"
                  onSubmit={this.handleOnSubmitCustomerFollowUp}
                >
                  <div className="card card card-accent-success">
                    <div className="card-header">
                      <strong>ข้อมูลการติดต่อ</strong> &nbsp;&nbsp;
                    </div>
                    <div className="card-block">
                      <div className="row">
                        {/*<div className="form-group col-sm-12">
                        <label htmlFor="customer_name">ครั้งที่ติดต่อ</label>
                        <input type="number"
                               className="form-control"
                               name="followup_times"
                               placeholder=""
                               maxLength={2}
                               value={this.state.followup_times || 0}
                               onChange={this.onInputChange}
                        />
                      </div>*/}
                        <div className="form-group col-sm-12">
                          <BDatePicker
                            isDateFill={0}
                            name={"contact_date"}
                            value={this.state.contact_date}
                            label={"วันที่ติดต่อ"}
                            onUpdateDate={(buddhist_date, christ_date) => {
                              this.setState({
                                contact_date: christ_date,
                              });
                            }}
                          />
                        </div>
                        <div className="form-group col-sm-12">
                          <BDatePicker
                            isDateFill={0}
                            name={"followup_date"}
                            value={this.state.followup_date}
                            label={"วันที่นัดหมาย"}
                            onUpdateDate={(buddhist_date, christ_date) => {
                              this.setState({
                                followup_date: christ_date,
                              });
                            }}
                          />
                        </div>
                        <div className="form-group col-sm-12">
                          <label htmlFor="customer_note">
                            รายละเอียดการติดต่อ
                          </label>
                          <textarea
                            className="form-control"
                            name="followup_detail"
                            placeholder=""
                            value={this.state.followup_detail || ""}
                            onChange={this.onInputChange}
                          />
                        </div>
                        <div className="form-group col-sm-12">
                          <label htmlFor="customer_mobile">
                            หัวข้อการติดตามครั้งถัดไป
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="followup_next"
                            placeholder=""
                            maxLength={200}
                            value={this.state.followup_next || ""}
                            onChange={this.onInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="card-footer text-right">
                      {this.state.followup_id === null ? (
                        <button type="submit" className="btn btn-primary">
                          <i className="icon-check"></i> บันทึกการติดตาม
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-warning">
                          <i className="icon-pencil"></i> แก้ไขการติดตาม
                        </button>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 text-right">
                <button
                  type="reset"
                  className="btn btn-sm btn-danger"
                  style={{ width: 120 }}
                  onClick={() => this.props.onToggle(this.state.is_reload)}
                >
                  <i className="fa fa-close"></i> ยกเลิก
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
        {/*<ModalFooter>
          <Button color="secondary" onClick={() => this.props.onToggle() }>ยกเลิก</Button>
        </ModalFooter>*/}
      </Modal>
    );
  }
}

export default CustomerFollowupForm;
